import { GridSortItem } from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { useEncounterCreationGate } from "../../hooks/use-encounter-creation-gate";
import { PatientMedicationControllerApi } from "../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  useBaseContent,
} from "../../utils/utils";

interface Props {
  patientUuid?: string;
  appointmentUuid?: any;
  pagination: DGT_Pagination;
  gridSorting?: GridSortItem[];
  status?: boolean;
  archive?: boolean;
  active?: boolean;
  searchString?: string;
  xTENANTID?: string | undefined;
  enabled?: boolean;
}

export type OptionData = {
  name: string;
  uuid: string;
};

/**
 *
 * @author Rajkumar Rathod
 */
export const usePatientMedicationList = ({
  patientUuid,
  appointmentUuid,
  pagination,
  gridSorting,
  status,
  archive,
  active: current,
  searchString,
  xTENANTID,
  enabled = true,
}: Props): useBaseContent<OptionData> => {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey: searchString,
    prevPage,
  });
  const pageSize = getPageSize(searchString, pagination);

  const sortData = gridSorting?.[0];
  const skip = useEncounterCreationGate();

  return useQuery({
    queryKey: [
      "patient-medication-list",
      patientUuid,
      appointmentUuid,
      xTENANTID,
      pageIndex,
      pageSize,
      current,
      status,
      archive,
      searchString,
      gridSorting,
      sortData,
    ],
    enabled: enabled && !skip,
    refetchOnWindowFocus: false,

    queryFn: async () =>
      await new PatientMedicationControllerApi(getConfigObject())
        .getPatientMedication(
          patientUuid,
          appointmentUuid,
          pageIndex, //page
          pageSize, //size
          sortData?.field,
          sortData?.sort ?? undefined, // sortDirection
          status,
          archive,
          current,
          searchString,
          xTENANTID // xTENANTID
        )
        .then((res) => res?.data),
  });
};
